/* eslint-disable padding-line-between-statements */
import { Loader, useModal } from '@jutro/components';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import _ from 'lodash';
import React, { useCallback, useContext, useState, useRef, useEffect } from 'react';
import { EntityUtil } from '@xengage/gw-portals-util-js';
import { TranslatorContext } from '@jutro/locale';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import TFPAAdditionalInsuredDetails from '../TFPAAdditionalInsuredDetails/TFPAAdditionalInsuredDetails.jsx';
import messages from './TFPAAdditionalInsuredComponent.messages.js';
import metadata from './TFPAAdditionalInsuredComponent.metadata.json5';
import styles from './TFPAAdditionalInsuredComponent.module.scss';

import { Button } from '@jutro/legacy/components';

import { DropdownMenuLink } from '@jutro/router';

function TFPAAdditionalInsuredComponent(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate } = props;
    const { authHeader } = useAuthentication();

    const viewModelService = useContext(ViewModelServiceContext);
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const [additionalInfoVM, setAdditionalInfoVM] = useState();
    const [showAdditionalInsured, setShowAdditionalInsured] = useState(false);
    const [addInsuredSpinner, setAddInsuredSpinner] = useState(false);
    const { showAlert, showConfirm } = useModal();
    const { refreshData } = useDataRefresh();
    const [additionalInsured, setAdditionalInsured] = useState([]);
    const additionalInsuredData = useRef(additionalInsured);
    const translator = useContext(TranslatorContext);
    const [editRowIndex, setEditRowIndex] = useState(null);
    const companySubtypeCode = 'Company';
    const personSubtypeCode = 'Person';
    const contactTypes = [{
        code: personSubtypeCode,
        name: translator(messages.individualTiltle)
    }, {
        code: companySubtypeCode,
        name: translator(messages.estateTitle)
    }];
    const jobType = _.get(submissionVM, 'baseData.jobType.value.code');

    useEffect(() => {
        additionalInsuredData.current = _.filter(submissionVM.baseData?.additionalNamedInsureds_TFPA?.value);
    }, [])

    // eslint-disable-next-line arrow-body-style
    const newContact = (data) => {
        return viewModelService.create(data || {},
            'pc',
            'org.tfpa.edge.capabilities.quote.submission.TFPAContactRoleDTO',
            { 'Submission_TFPA': true, 'AccountHolderInfo_TFPA': false, 'AdditionalInsureds_TFPA': true });
    };


    const newAdditionalInsured = (subtype) => {
        let additionalInsuredRole = 'Co-owner';

        if (subtype === companySubtypeCode) {
            additionalInsuredRole = 'Estate/Trust';
        }

        const contact = { tempID: EntityUtil.nextId(), subtype: subtype, primaryAddress: null };

        return newContact({
            descriptionInterest: additionalInsuredRole,
            subtype: 'PolicyAddlNamedInsured',
            accountContactDTO: contact
        });
    };

    const addContacts = useCallback(
        (event) => {
            event.preventDefault();
            const additionalValue = event.currentTarget.dataset.code;
            const value = newAdditionalInsured(additionalValue);
            setAdditionalInfoVM(value);
            setShowAdditionalInsured(true);
        },
        [newAdditionalInsured]
    );


    const oldVMData = [];

    const cancelAdditionalInsureds = () => {
        setAdditionalInfoVM(oldVMData);
        setShowAdditionalInsured(false);
    };

    const saveAdditionalInterest = async () => {
        setAddInsuredSpinner(true);
        submissionVM.baseData.validatePreQual = false;
        // DE17614
        await LoadSaveService.updateQuotedSubmission(submissionVM.value, authHeader).then((result) => {
            if (result) {
                submissionVM.baseData.additionalNamedInsureds_TFPA.value = result.baseData.additionalNamedInsureds_TFPA;
                additionalInsuredData.current.push(additionalInfoVM.value)
                submissionVM.baseData.additionalNamedInsureds_TFPA.value = (additionalInsuredData.current);
                setAddInsuredSpinner(false);
            }
        })

    }

    const saveAdditionalInsureds = async (updatedData) => {
        const newItem = [...additionalInsuredData.current, updatedData.value];

        await saveAdditionalInterest()
        updateWizardData(submissionVM);
        setShowAdditionalInsured(false);
    };

    const deleteAdditionalInterest = async (item, index) => {

        additionalInsuredData.current = additionalInsuredData.current.filter((_, i) => i !== index);
        submissionVM.baseData.additionalNamedInsureds_TFPA.value = (additionalInsuredData.current);
        setAdditionalInsured(additionalInsuredData.current)
        setEditRowIndex(null);
    }

    const deleteRow = async (item, index) => {
        showConfirm({
            title: messages.removeAdditionalInsured,
            message: messages.removeAddlInsuredMessage,
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.yesModel,
            cancelButtonText: messages.noModal, // DE16323
            className: styles.jut__Button__filled,
        }).then(async (results) => {

            if (results === 'cancel' || results === 'close') {
                return _.noop();
            }

            await deleteAdditionalInterest(item, index);
            updateWizardData(submissionVM);

            return true;
        }, _.noop)
    };

    const editRow = (index) => {
        const data = additionalInsuredData.current[index];
        const newVmData = newContact({
            descriptionInterest: data.descriptionInterest,
            subtype: data.subtype,
            accountContactDTO: data.accountContactDTO,
            relationshipToInsured: data.relationshipToInsured
        });
        setAdditionalInfoVM(newVmData);
        setEditRowIndex(index);
        setShowAdditionalInsured(true);
    };


    const saveEditedRow = async () => {
        setAddInsuredSpinner(true);
        if (editRowIndex !== null) {
            additionalInsuredData.current[editRowIndex] = additionalInfoVM.value;
            submissionVM.baseData.additionalNamedInsureds_TFPA.value = [...additionalInsuredData.current];

            await LoadSaveService.updateQuotedSubmission(submissionVM.value, authHeader) // DE17614
                .then((result) => {
                    if (result) {
                        additionalInsuredData.current = result.baseData.additionalNamedInsureds_TFPA;
                        setAdditionalInsured([...additionalInsuredData.current]);
                        setShowAdditionalInsured(false);
                        setEditRowIndex(null);
                        setAddInsuredSpinner(false);
                    }
                });
        }
    };

    const getName = (item) => item.accountContactDTO.subtype === 'Person' ? item.accountContactDTO.firstName + " " + item.accountContactDTO.lastName : item.accountContactDTO.contactName;

    const getDescriptionOfInterest = (item) => item.descriptionInterest

    const getRelationship = (item) => item.relationshipToInsured;

    const actionButtons = (item, index) => (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
                className={styles.buttons}
                type="text"
                icon="gw-delete"
                onClick={() => deleteRow(item, index)}
                aria-label="Delete Row"
            />
            <Button
                className={styles.buttons}
                type="text"
                icon="gw-edit"
                onClick={() => editRow(index)}
                aria-label="Edit Row"
            />
        </div>
    );

    const writeValue = useCallback(
        (value, path) => {
            _.set(submissionVM, path, value);
            updateWizardData(submissionVM);
            refreshData();
        },
        [submissionVM, refreshData, updateWizardData]
    );

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        additionalInsuredSection: {
            visible: showAdditionalInsured,
            item: additionalInfoVM,
            saveData: editRowIndex !== null ? saveEditedRow : saveAdditionalInsureds,
            cancelData: cancelAdditionalInsureds,
            isInvalid: findInvalidComponent,
            showErrors,
            onValidate,
            editRowIndex
        },
        additionalInterestTable: {
            data: additionalInsuredData.current
        },
        addMenuButton: {
            visible: jobType !== 'PolicyChange',
            content: (
                <React.Fragment>
                    <DropdownMenuLink
                        onClick={addContacts}
                        data-code={personSubtypeCode}
                    >
                        {contactTypes[0].name}
                    </DropdownMenuLink>
                    <DropdownMenuLink
                        onClick={addContacts}
                        data-code={companySubtypeCode}
                    >
                        {contactTypes[1].name}
                    </DropdownMenuLink>
                </React.Fragment>
            )
        },
        actionColumn:{
            visible: jobType !== 'PolicyChange', 
        }

    };


    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: { addtionalInsuredDetailsComponent: TFPAAdditionalInsuredDetails },
        resolveCallbackMap: {
            getName,
            getRelationship,
            getDescriptionOfInterest,
            actionButtons,
            addContacts
        },
    };


    return (
        <Loader loaded={!addInsuredSpinner}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                onValueChange={writeValue}
            />
        </Loader>
    );
}

export default TFPAAdditionalInsuredComponent;
